import { store } from "../../store";
import {
    getAccountName, getLocationName,
    getPaymentMethodName, getProductUnitName, getTaxCode, getTermName,
} from "../../List/helper/getListItemNameHelper";

// account_id, location_id,  tax_code_id, parent_id (?), product_id, product_unit_id,
export const getFormItemNames = (item, autosave_id = null) => {
    const { List } = store.getState();
    const obj = {};

    if (item.account_id)
        obj.account_id = getAccountName(item.account_id);

    if (item.location_id)
        obj.location_id = getLocationName(item.location_id);

    if (item.tax_code_id)
        obj.tax_code_id = getTaxCode(item.tax_code_id);

    let product;
    if (item.product_id) {
        product = List.productList.find(product => product.id === item.product_id);
        obj.product_id = product?.name;
    }

    if (product && item.product_unit_id)
        obj.product_unit_id = getProductUnitName(item.product_unit_id, product);

    // Add an autosave ID for each item in local storage.
    // This ID is used to find/map to the item in the autosave_text_values' items, to retrieve that item's texts eg Account name etc.
    if (autosave_id || autosave_id === 0) // cater for index 0
        obj.autosave_id = autosave_id;
    return obj;
};

// account_id, tax_code_id. Used by both bank_items and journal_items
export const getBankItemNames = (item, autosave_id = null) => {
    const obj = {};
    if (item.account_id)
        obj.account_id = getAccountName(item.account_id);

    if (item.tax_code_id)
        obj.tax_code_id = getTaxCode(item.tax_code_id);

    // Add an autosave ID for each item in local storage.
    // This ID is used to find/map to the item in the autosave_text_values' items, to retrieve that item's texts eg Account name etc.
    if (autosave_id || autosave_id === 0) // cater for index 0
        obj.autosave_id = autosave_id;

    return obj;
};

// account_id, fee_account_id, payment_method_id
export const getDepositItemNames = (item, autosave_id = null) => {
    const obj = {};
    if (item.account_id)
        obj.account_id = getAccountName(item.account_id);

    if (item.fee_account_id)
        obj.fee_account_id = getAccountName(item.fee_account_id);

    if (item.payment_method_id)
        obj.payment_method_id = getPaymentMethodName(item.payment_method_id);

    // Add an autosave ID for each item in local storage.
    // This ID is used to find/map to the item in the autosave_text_values' items, to retrieve that item's texts eg Account name etc.
    if (autosave_id || autosave_id === 0) // cater for index 0
        obj.autosave_id = autosave_id;

    return obj;
};

// location_id, location2_id, product_id, product_unit_id
export const getItemNames = (item, autosave_id = null) => {
    const { List } = store.getState();
    const obj = {};

    if (item.location_id)
        obj.location_id = getLocationName(item.location_id);

    if (item.location2_id)
        obj.location2_id = getLocationName(item.location2_id);

    let product;
    if (item.product_id) {
        product = List.productList.find(product => product.id === item.product_id);
        obj.product_id = product?.name;
    }

    if (product && item.product_unit_id)
        obj.product_unit_id = getProductUnitName(item.product_unit_id, product);

    // Add an autosave ID for each item in local storage.
    // This ID is used to find/map to the item in the autosave_text_values' items, to retrieve that item's texts eg Account name etc.
    if (autosave_id || autosave_id === 0) // cater for index 0
        obj.autosave_id = autosave_id;
    return obj;
};

// term_id
export const getTermItemNames = (item, autosave_id = null) => {
    const obj = {};
    if (item.term_id)
        obj.term_id = getTermName(item.term_id);

    // Add an autosave ID for each item in local storage.
    // This ID is used to find/map to the item in the autosave_text_values' items, to retrieve that item's texts eg Account name etc.
    if (autosave_id || autosave_id === 0) // cater for index 0
        obj.autosave_id = autosave_id;

    return obj;
};
